import React, { useState, useEffect } from 'react'
import useStores from '../../../stores/useStore'
import { Modal, Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import ArraySelect from '../../Select/ArraySelect'
import { ButtonWithLoadingState } from '../../Buttons'
import { emptyGuid, isEmptyGuid } from '../../../utils/emptyGuid'
import instMgmtApi from '../../../utils/api/instanceMgmt/instMgmtApi'
import { makeCall } from '../../../utils/api/makeCall'


const StyledButtonsWrapper = styled.div`
    .btn {
        margin: 4px;
    }
    display: flex;
    width: 100%;
    justify-content: space-between;
    
    @media screen and (max-width: 767px) {
        flex-direction: column;
        width: 100%;
    }
`


const WashStationSelectModal = ({ handleClose}) => {
    const { t } = useTranslation()
    const { washStore } = useStores()
    const [stationId, setStationId] = useState(emptyGuid);
    const [stations, setStations] = useState([])
    const [, setErrorStates] = useState({})
    const [, setLoadingStates] = useState({})

    const loadStations = async () => {
        await makeCall('washStations', async () => {
            var result = await instMgmtApi.getWashStations()
            setStations(result)
        }, setErrorStates, setLoadingStates)
    }
    useEffect(() => {
        loadStations()
    }, [])
    useEffect(() => {
        let washSelectedStationId = washStore.getSelectedWashStationId()
        setStationId(washSelectedStationId)
    }, [washStore, setStationId])

    const handleSubmit = async (event) => {
        event.preventDefault()
        event.stopPropagation()
        washStore.setSelectedWashStationId(stationId)
        await washStore.loadWashStation(true)
        handleClose(true)
    }
    
    return (
        <Modal style={{ textAlign: "center" }} centered show={true} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton={washStore.checkWashStationIsSelected()}>
                <Modal.Title >{t('washPage:changeStation')}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <Form>
                    <Form.Group className="mb-3">
                        {/*<Form.Label>{t('washPage:station')}</Form.Label>*/}
                        <ArraySelect
                            value={stationId ?? emptyGuid}
                            options={stations}
                            noAutoSelect
                            name='station'
                            onChange={(e) => setStationId(e.target.value)}
                            defaultOptionIsSelectable={isEmptyGuid(stationId)}
                            returnEvent
                        />
                    </Form.Group>
                </Form>
            </Modal.Body >
            <Modal.Footer className="justify-content-start">
                <StyledButtonsWrapper>
                    <ButtonWithLoadingState
                        buttonText={t('saveButton')}
                        loadingText={t('saveButton')}
                        type="submit"
                        form="my-form"
                        disabled={isEmptyGuid(stationId)}
                        onClick={handleSubmit}
                    />
                </StyledButtonsWrapper>
            </Modal.Footer>
        </Modal>
    )
}

export default WashStationSelectModal